<div style="position:absolute;margin-top:0.5rem;font-size:.75rem" [class.hide]="_hide">
    <mat-error>
        {{_text}}
    </mat-error>
</div>